export default (fn) => {
  const isClient = typeof window !== 'undefined';
  switch (typeof fn) {
    case 'undefined':
      return isClient;
    case 'function':
      return isClient && fn();
    default:
      return isClient && fn;
  }
};
